import { useEffect } from 'react';
import { usePart, KEYBOARD_SHORTCUTS } from '@midi-volca-drum/midi';

/**
 * Keyboard shortcuts:
 * - Escape: Close modals
 * - Alt+1-6: Switch parts
 * - Alt+W: Waveguide
 */
export function useKeyboardShortcuts(
  options: {
    onEscape?: () => void;
    enablePartSwitching?: boolean;
  } = {}
) {
  const { onEscape, enablePartSwitching = true } = options;
  const { switchPart, switchToWaveguide } = usePart();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === KEYBOARD_SHORTCUTS.ESCAPE && onEscape) {
        onEscape();
        return;
      }

      if (enablePartSwitching && event.altKey) {
        if (
          KEYBOARD_SHORTCUTS.PART_CODES.includes(
            event.code as (typeof KEYBOARD_SHORTCUTS.PART_CODES)[number]
          )
        ) {
          event.preventDefault();
          switchPart(parseInt(event.code.replace('Digit', '')));
          return;
        }

        if (
          KEYBOARD_SHORTCUTS.WAVEGUIDE_CODES.includes(
            event.code as (typeof KEYBOARD_SHORTCUTS.WAVEGUIDE_CODES)[number]
          )
        ) {
          event.preventDefault();
          switchToWaveguide();
          return;
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape, enablePartSwitching, switchPart, switchToWaveguide]);
}
